/* =========================================================
   Datos de los kits (salen de "🛍️ Páginas de producto - Kits")
   y armado de la landing de cada kit.
   ========================================================= */
const KITS = {
  energia: {
    theme: 't-energia',
    name: 'Kit Energía Hombre 40+',
    short: 'Kit Energía',
    eyebrow: 'Kit Energía · Hombre 40+',
    h1: 'Vuelve a llegar con ganas.',
    sub: 'Shilajit en gomitas + Turkesterona, en un solo pedido. Una rutina, no un milagro.',
    badge: ['Nuevo', 'Kit de 2 o 3'],
    products: [
      { img: 'shilajit', name: 'Shilajit Gummies', brand: 'Buporai', tags: ['Gomitas, sin agua', 'Frambuesa y sandía'], line: 'El shilajit es una resina de montaña que la tradición ayurvédica usa hace siglos. Aquí viene en gomitas: nada de resina pegajosa ni sabor amargo.',
        facts: [['Porción', '2 gomitas al día'], ['Duración', '30 días (60 gomitas)'], ['Por porción', 'Equivale a 1.000 mg de shilajit'], ['Sabor', 'Frambuesa y sandía']] },
      { img: 'turkesterona', name: 'Turkesterone', brand: 'Old School · hecha en Chile', tags: ['Hecha en Chile', '60 cápsulas'], line: 'Turkesterona con clavo de huasca, L-arginina, guaraná y ginseng panax.',
        facts: [['Formato', '60 cápsulas'], ['Tipo', 'Alimento para deportistas'], ['Toma', 'Según la porción de su etiqueta']] },
      { img: 'nad', name: "NAD+ Men's Complex", brand: 'Selerb', only: true, tags: ['Cápsulas vegetales'], line: 'NAD+ con resveratrol, CoQ10, L-arginina, maca y cúrcuma, en un solo frasco. Distintos estudios muestran que los niveles de NAD+ bajan con la edad.',
        facts: [['Formato', '60 cápsulas vegetales'], ['Porción', '2 cápsulas al día'], ['Duración', '30 días']] },
    ],
    problem: {
      title: 'A las 9 ya estás dormido con la tele prendida.',
      text: 'Llegas del trabajo, comes algo y te sientas “un ratito” en el sillón. Antes salías después de la pega, jugabas la pichanga del sábado entera y el domingo tenía panorama.',
      agTitle: 'Y lo peor es que uno se acostumbra',
      bullets: ['El panorama del fin de semana que se posterga “para la otra”.', 'La pichanga a la que ya no vas, porque en el segundo tiempo no das más.', 'Los niños que te piden otro partido y tú mirando el reloj.', 'Las ganas van por un lado y el cuerpo por otro.'],
      slot: 'problema-energia-v2.png', icon: 'sofa',
    },
    ba: {
      before: { time: '21:00', text: 'Un momento de pausa al final de un día largo.', icon: 'sofa', slot: 'antes-energia-v2.png' },
      after: { time: '21:00', text: 'Compartir un rato de juego con los niños.', icon: 'ball', slot: 'despues-energia-v2.png' },
    },
    solTitle: 'Por eso armamos el Kit Energía Hombre 40+',
    solSub: 'Una rutina diaria simple, con suplementos que hoy se compran por separado, en un solo pedido.',
    easy: [['Con el desayuno', 'Cada producto según la porción de su etiqueta. Las gomitas no necesitan agua.'], ['A la misma hora', 'Todos los días, idealmente a la misma hora, para que se vuelva rutina.'], ['NAD+ (Completo)', '2 cápsulas al día con agua, idealmente con una comida.']],
    days: [['En la pega', 'briefcase', '#3A3222,#141414'], ['En la pichanga', 'ball', '#4B5D2A,#1A2410'], ['Con los niños', 'users', '#7A5A1E,#2A1E08'], ['En el gym', 'dumbbell', '#2B2B2B,#0A0A0A'], ['El fin de semana', 'sun', '#B8860B,#4A3505'], ['Después de los 40', 'calendar', '#5A4A2A,#1C160B']],
    forwho: {
      yes: ['Para el hombre que quiere sumar una rutina simple y constante a su día.', 'Para quien prefiere recibir todo junto y pagar al recibir.'],
      no: ['No es para menores de 15 años, embarazadas ni mujeres en lactancia (lo indican las etiquetas).', 'No es para quien busca un efecto inmediato. No reemplaza una alimentación equilibrada, el descanso ni las indicaciones de un médico.'],
    },
    faq: [
      ['¿Las gomitas de shilajit son iguales a la resina?', 'Es el mismo ingrediente en otro formato: gomitas en vez de resina, más fácil de tomar todos los días.'],
      ['¿Cuándo se nota?', 'Cada persona es distinta. Es un suplemento y se toma con constancia diaria; no es de efecto inmediato.'],
      ['¿Cómo pago?', 'Pagas en tu casa, al recibir el pedido. No pagas nada por adelantado.'],
      // [anterior: Claude Code, 2026-09-15] 'Normalmente 1 a 2 días hábiles en la Región Metropolitana y 2 a 5 en regiones.'
      ['¿Cuánto demora?', 'Preparamos tu pedido en 1 a 2 días hábiles. Desde el despacho, llega en 1 a 3 días hábiles en la Región Metropolitana y 2 a 7 en regiones.'],
      ['¿Llega todo junto?', 'Sí, los productos salen de la misma bodega en un solo envío.'],
      ['¿Puedo tomarlo si tomo medicamentos?', 'Consulta antes a tu médico. Lo recomendamos siempre antes de empezar cualquier suplemento.'],
      ['¿Es para mujeres?', 'Este kit está pensado para hombres. Para mujeres está el Kit Mujer Fuerte.'],
    ],
    baPoints: [
      ['clock', 'La misma hora', 'Las dos fotos son a las 21:00. Lo que cambia no es el reloj: es la rutina que hubo durante el día.'],
      ['box', 'Un solo pedido', 'Productos que hoy se compran por separado, en un envío y un solo paquete.'],
      ['cash', 'Sin arriesgar plata', 'Pagas en tu casa cuando llega, y tienes 30 días para devolverlo.'],
    ],
    upsell: 'el NAD+',
    legal: 'Estos productos son suplementos alimentarios y alimentos para deportistas; no son medicamentos. No están destinados a diagnosticar, tratar, curar ni prevenir enfermedades. No reemplazan una alimentación equilibrada. No recomendables para menores de 15 años, embarazadas ni nodrizas, salvo indicación de un profesional. Consulte a su médico si toma medicamentos o tiene alguna condición de salud. Mantener fuera del alcance de los niños.',
  },

  mujer: {
    theme: 't-mujer',
    name: 'Kit Mujer Fuerte',
    short: 'Kit Mujer Fuerte',
    eyebrow: 'Kit Mujer Fuerte',
    h1: 'Lo que se siente y lo que se ve, en una sola rutina.',
    sub: 'Creatina for Women + Colágeno. Y no, no es solo para el gym.',
    badge: ['1 minuto', 'al día'],
    products: [
      { img: 'creatina', name: 'Creatine Monohydrate for Women', brand: 'Old School', tags: ['Sin sabor', 'Sin azúcar añadida'], line: 'Uno de los suplementos más estudiados del mundo. Polvo sin sabor que se mezcla en el agua, el jugo o el batido del desayuno.',
        facts: [['Por porción', '5 g creatina + 2 g colágeno + 1 g BCAA'], ['Duración', '30 porciones (1 mes)'], ['Sabor', 'Sin sabor, sin azúcar añadida'], ['Formato', '240 g']] },
      { img: 'colageno', name: 'Collagen Peptides Type I', brand: 'Toplux Nutrition', tags: ['Nada que mezclar', 'Sello de seguridad'], line: 'Colágeno tipo I hidrolizado, en cápsulas: nada que mezclar ni medir.',
        facts: [['Formato', '60 cápsulas'], ['Por porción', '460 mg'], ['Toma', 'Según la porción de su etiqueta']] },
      { img: 'magnesio', name: 'Magnesium 12-in-1 Complex', brand: 'Totaria Health', only: true, tags: ['Sin OGM', '6 tipos de magnesio'], line: '6 tipos de magnesio en un frasco. El magnesio participa en más de 300 procesos del cuerpo.',
        facts: [['Porción', '1 cápsula al día'], ['Duración', '60 días'], ['Por cápsula', '720 mg (241 mg de magnesio elemental)']] },
    ],
    problem: {
      title: 'La primera jornada termina a las 6. La segunda, a las 11 de la noche.',
      text: 'Trabajo. Almuerzo de los niños. Tareas. Supermercado. La once. Y cuando por fin te sientas, alguien te dice: “tienes que tomarte un tiempo para ti”.',
      agTitle: 'Y lo tuyo siempre queda para “cuando haya tiempo”',
      bullets: ['El gimnasio que empieza “el lunes” desde hace un año.', 'El colágeno que compraste un mes y quedó olvidado en el cajón.', 'La creatina que viste en redes, pero que parece “solo para los del gym”.', 'Ser el motor de la casa, sin que nadie revise el motor.'],
      slot: 'problema-mujer.jpg', icon: 'clock',
    },
    ba: {
      before: { time: '23:00', text: 'La noche termina entre tareas y pendientes.', icon: 'moon', slot: 'antes-mujer-v2.png' },
      after: { time: '07:30', text: 'Empezar la mañana con un momento para ti y los niños.', icon: 'sun', slot: 'despues-mujer-v4.png' },
    },
    solTitle: 'Una rutina de 1 minuto al día, vayas o no al gimnasio',
    solSub: 'Suplementos que hoy se compran por separado, juntos en un solo pedido.',
    easy: [['Creatina', '1 porción al día en agua, jugo o batido. A cualquier hora.'], ['Colágeno', 'En la mañana, según la porción de su etiqueta.'], ['Magnesio (Completo)', '1 cápsula al día. Muchas personas lo toman en la tarde o la noche.']],
    days: [['En la oficina', 'briefcase', '#8E4A7C,#4A1A3E'], ['En el gym', 'dumbbell', '#6B2D5C,#2E0F27'], ['Con los niños', 'users', '#C47FA2,#6B2D5C'], ['En casa', 'home', '#B5708F,#5A2149'], ['En tu tiempo', 'heart', '#E3A1BF,#8E4A7C'], ['Todos los días', 'calendar', '#7D3A6B,#3A1231']],
    forwho: {
      yes: ['Para la mujer que quiere una rutina simple, vaya o no al gimnasio.', 'Para quien quiere juntar en un pedido lo que compraría por separado.'],
      no: ['No es para menores de 8 años, embarazadas ni mujeres en lactancia, salvo indicación profesional (lo indican las etiquetas).', 'No es un producto para bajar de peso.'],
    },
    faq: [
      ['¿Tengo que ir al gimnasio para tomar creatina?', 'No. Se asocia al gimnasio, pero muchas personas la suman a su rutina diaria sin entrenar.'],
      ['¿La creatina tiene sabor?', 'No: es polvo sin sabor y sin azúcar añadida, según su etiqueta. Se mezcla con lo que tomes en el desayuno.'],
      ['¿Cuánto dura?', 'La creatina trae 30 porciones (1 mes). El magnesio es 1 cápsula al día (2 meses). El colágeno trae 60 cápsulas y se toma según la porción de su etiqueta.'],
      ['¿Cómo pago?', 'Pagas en tu casa, cuando el pedido llega. Nada por adelantado.'],
      // [anterior: Claude Code, 2026-09-15] 'Normalmente 1 a 2 días hábiles en la Región Metropolitana y 2 a 5 en regiones.'
      ['¿Cuánto demora?', 'Preparamos tu pedido en 1 a 2 días hábiles. Desde el despacho, llega en 1 a 3 días hábiles en la Región Metropolitana y 2 a 7 en regiones.'],
      ['¿Puedo tomarlo si estoy embarazada, en lactancia o tomo medicamentos?', 'No se recomienda en embarazo ni lactancia sin indicación profesional. Si tomas medicamentos, consulta a tu médico.'],
    ],
    baPoints: [
      ['clock', 'Un minuto al día', 'No hay que ir al gimnasio ni cambiar tu día: se mezcla con lo que ya tomas en el desayuno.'],
      ['box', 'Un solo pedido', 'Lo que hoy comprarías en dos tiendas distintas, en un envío y un solo paquete.'],
      ['cash', 'Sin arriesgar plata', 'Pagas en tu casa cuando llega, y tienes 30 días para devolverlo.'],
    ],
    upsell: 'el magnesio',
    legal: 'Estos productos son suplementos alimentarios; no son medicamentos. No están destinados a diagnosticar, tratar, curar ni prevenir enfermedades. No reemplazan una alimentación equilibrada. Su consumo no es recomendable para menores de 8 años, embarazadas ni nodrizas, salvo indicación de un profesional competente. Mantener fuera del alcance de los niños.',
  },
};

/* [2026-09-20] se llamaba PACKS. Chocaba con el PACKS de productos.js, que son
   los packs por producto: al cargar los dos archivos en la misma página el
   navegador se caía con "PACKS has already been declared". Estos son los packs
   del KIT (básico y completo), por eso el nombre nuevo. */
const KIT_PACKS = {
  /* [2026-10-03] El tachado es la suma de los productos a su precio de ficha
     ($44.900 c/u). Decía $79.800 / $119.700 (a $39.900, precio viejo): cada
     producto aparecía en el kit a $39.900 y en su ficha a $44.900.
     [anterior: Claude Code] strike: 79800 · strike: 119700 */
  basico: { name: 'Básico', count: 2, price: 44900, strike: 89800 },
  completo: { name: 'Completo', count: 3, price: 49900, strike: 134700 },
};

/* [2026-09-28] Sirve la foto limpia del catalogo (${AS_A}img-productos-<id>).
   [anterior: 2026-09-27] apuntaba a ${AS_A}img-kit-<nombre>, los recortes con
   fondo transparente, que estaban mal hechos. [anterior: hasta 2026-09-27]
   apuntaba a ${AS_A}img-<nombre>.jpg, las fotos del proveedor (Dropi). */
/* [2026-09-28] Pasa a los recortes sin fondo: en las páginas de kit la foto
   con fondo blanco dejaba un cuadrado blanco sobre el color de la tarjeta.
   [anterior] const shot = (img, alt = '') => `<div class="shot">${fotoProducto(img, alt) || ''}</div>`; */
const shot = (img, alt = '') => `<div class="shot">${fotoSinFondo(img, alt) || fotoProducto(img, alt) || ''}</div>`;

function bigQuote(key) {
  if (!STORE.demoPersonas || typeof PERSONAS === 'undefined') return '';
  const p = PERSONAS.filter((x) => x.kit === key)[1] || PERSONAS[0];
  return `<div class="bigquote" data-rv style="margin-bottom:56px"><blockquote>${p.quote}</blockquote>${stars()}<span><b>${p.name}</b> · ${p.meta} · <span class="demo-tag" style="position:static">Personaje de ejemplo (IA)</span></span></div>`;
}

/* tabla de valor según el pack elegido (AG1 "la primera compra incluye") */
function renderStack(k, packId) {
  const el = document.querySelector('[data-stack]');
  if (!el) return;
  const p = KIT_PACKS[packId];
  const items = k.products.slice(0, p.count);
  el.innerHTML = `<div class="stack-h">Tu ${k.short} ${p.name} incluye</div>
    ${items.map((x) => `<div class="stack-row"><span>${x.name}<small>${x.brand}</small></span><span class="v">${clp(p.strike / p.count)}</span></div>`).join('')}
    <div class="stack-row"><span>Guía “Tu rutina de 30 días” + calendario<small>Digital, te llega con tu pedido</small></span><span class="v free">GRATIS</span></div>
    <div class="stack-row"><span>Envío a todo Chile<small>1 solo paquete</small></span><span class="v free">GRATIS</span></div>
    <div class="stack-total"><span>Pagas hoy <s>${clp(p.strike)}</s></span><b>${clp(p.price)}</b></div>
    <span class="disc-line disc-no" data-disc-price="${p.price}" data-oferta style="text-align:right"></span>`;
  /* [anterior 2026-09-20] aquí se restaba el descuento de bienvenida al precio del
     kit. Ya no: los kits tienen precio tachado y "ahorras", o sea que ya son una
     oferta, y las ofertas no se acumulan (regla de Jacsson, 2026-09-20). */
  if (document.body.classList.contains('has-disc')) {
    el.querySelector('.disc-line').textContent = 'El kit ya tiene precio de oferta';
  }
}

function heroProof(key) {
  /* [2026-09-27] Antes, cuando no había personas que mostrar, esto devolvía
     5 estrellas y el texto de relleno “[Reseña corta real]” · [Nombre], [Ciudad].
     Eso se le veía al cliente en cuanto demoPersonas pasara a false, que es
     justo lo que va a pasar antes de vender.

     Ahora no devuelve nada. Sin reseñas reales no va ni el texto ni —sobre
     todo— las 5 estrellas, que sin reseñas se leen como una nota que no existe.
     Cuando haya opiniones de verdad, aquí se arma la de mejor nota. */
  if (!STORE.demoPersonas || typeof PERSONAS === 'undefined') return '';
  const p = PERSONAS.find((x) => x.kit === key);
  const ini = p.name.split(' ').map((w) => w[0]).join('').replace('.', '');
  return `<div class="persona-chip"><span class="pc-av" style="--g:linear-gradient(160deg,${p.g})">${ini}</span><span>${stars()}<br>“${p.quote}” <small>${p.name}, ${p.meta} · personaje de ejemplo (IA)</small></span></div>`;
}

function renderKit(key) {
  const k = KITS[key];
  document.body.classList.add(k.theme);
  const [p1, p2, p3] = k.products;
  const main = document.querySelector('main');

  const packCard = (id) => {
    const p = KIT_PACKS[id], best = id === 'completo';
    const items = k.products.slice(0, p.count);
    const thumbs = items.map((x) => shot(x.img, x.name)).join('') + (best ? '' : `<span class="plus-slot" title="Solo en el Completo">${ic('plus')}</span>`);
    const per = Math.round(p.price / p.count);
    return `<label class="pack${best ? ' best' : ''}">
      <input type="radio" name="pack" id="pack-${id}" value="${id}"${best ? ' checked' : ''}>
      ${best ? `<span class="ribbon">${ic('star')}Recomendado</span>` : ''}
      <div class="pack-head"><div><div class="pack-name">${p.name}</div><div class="pack-sub">${p.count} productos · 1 solo envío</div></div><span class="radio"></span></div>
      <div class="pack-thumbs">${thumbs}</div>
      <div class="price-row"><span class="price">${clp(p.price)}</span><span class="strike">${clp(p.strike)}</span><span class="save">Ahorras ${clp(p.strike - p.price)}</span></div>
      <span class="disc-line disc-no" data-disc-price="${p.price}" data-oferta></span>
      ${best ? `<span class="pack-per">Solo ${clp(per)} por producto · ≈ ${clp(Math.round(p.price / 30))} al día</span>` : `<span class="pack-per">≈ ${clp(Math.round(p.price / 30))} al día</span>`}
      <ul>${items.map((x) => `<li>${ic('check')}${x.name}</li>`).join('')}<li>${ic('check')}Envío gratis y pago al recibir</li><li>${ic('check')}Garantía de 30 días</li><li>${ic('gift')}<b>Regalo: guía “Tu rutina de 30 días”</b></li></ul>
      <!-- [2026-09-27] se quitó el bloque de valoración vacía (5 estrellas + "Sé el primero en opinar"): pedido de Jacsson. Las estrellas se van JUNTO con el texto porque 5 estrellas doradas sin ninguna reseña se leen como un 5 de 5 que no existe. Vuelve cuando haya reseñas reales. -->
    </label>`;
  };

  const dayCard = ([label, icon, g], i) => `<div class="day" style="--g:linear-gradient(160deg,${g});--d:${i * 70}ms"><span class="day-art" aria-hidden="true">${ic(icon)}</span><span class="day-ic">${ic(icon)}</span><b>${label}</b></div>`;

  main.innerHTML = `
  <section class="kit-hero">
    <div class="wrap kit-hero-grid">
      <div class="hero-copy">
        <span class="eyebrow">${k.eyebrow}</span>
        <h1>${k.h1}</h1>
        <!-- [2026-09-27] se quitó el bloque de valoración vacía (5 estrellas + "Sé el primero en opinar"): pedido de Jacsson. Las estrellas se van JUNTO con el texto porque 5 estrellas doradas sin ninguna reseña se leen como un 5 de 5 que no existe. Vuelve cuando haya reseñas reales. -->
        <p class="lead">${k.sub}</p>
        <div class="countdown" data-countdown>${ic('clock')}<span>${STORE.offerName}: termina el ${STORE.offerEndText}</span><span class="cd">--</span></div>
        <div class="btn-row"><a class="btn btn-cta" href="#ofertas">Ver ofertas ${ic('arrow')}</a><a class="btn btn-ghost" href="#rutina">Cómo funciona</a></div>
        <div class="trust-mini"><span>${ic('truck')}Envío gratis</span><span>${ic('cash')}Paga en tu casa</span><span>${ic('clock')}Despacho 24–48 h</span></div>
        ${heroProof(key)}
      </div>
      <div class="stage" aria-label="Productos del kit">
        ${shot(p1.img, p1.name)}${shot(p2.img, p2.name)}${shot(p3.img, p3.name)}
        <span class="stage-badge"><span><small>desde</small>$44.900</span></span>
      </div>
    </div>
  </section>


  <section class="sec-tight">
    <div class="wrap sec-head center" data-rv>
      <span class="eyebrow">Comunidad Allsupletion</span>
      <h2>Lo que dicen quienes ya lo usan</h2>
      <span class="reviews-note">Personajes de ejemplo creados con IA · se reemplazan por clientes reales</span>
    </div>
    <div class="marquee" data-personas="${key}"></div>
  </section>

  <section class="sec">
    <div class="wrap problem">
      <div class="problem-text" data-rv>
        <span class="eyebrow" style="justify-self:start">¿Te suena?</span>
        <h2>${k.problem.title}</h2>
        <p>${k.problem.text}</p>
        <h3 style="margin-top:6px">${k.problem.agTitle}</h3>
        <ul class="checklist">${k.problem.bullets.map((b) => `<li><span class="ck">${ic('check')}</span>${b}</li>`).join('')}</ul>
        <a class="btn btn-ghost" href="#antes" style="justify-self:start">Ver la solución ${ic('arrow')}</a>
      </div>
      <div class="slot" data-rv><img src="${AS_A}img-clientes-${k.problem.slot.replace('.jpg', '.webp')}" alt="${k.problem.agTitle}" loading="lazy" decoding="async"></div>
    </div>
  </section>

  <section class="sec alt" id="antes">
    <div class="wrap">
      <div class="ba-split" data-rv>
      <div class="ba-wrap">
        <div class="ba" style="--pos:50%">
          <div class="ba-layer ba-before">
            <img class="ba-photo" src="${AS_A}img-clientes-${k.ba.before.slot.replace('.jpg', '.webp')}" alt="${k.ba.before.text}" loading="lazy" decoding="async">
            <div class="ba-top"><span class="ba-label">Antes</span></div>
            <div class="ba-bottom"><span class="ba-time">${k.ba.before.time}</span><p class="ba-text">${k.ba.before.text}</p></div>
          </div>
          <div class="ba-layer ba-after">
            <img class="ba-photo" src="${AS_A}img-clientes-${k.ba.after.slot.replace('.jpg', '.webp')}" alt="${k.ba.after.text}" loading="lazy" decoding="async">
            <div class="ba-top"><span class="ba-label">Con tu rutina</span></div>
            <div class="ba-bottom"><span class="ba-time">${k.ba.after.time}</span><p class="ba-text">${k.ba.after.text}</p></div>
          </div>
          <div class="ba-handle"><span>${ic('swap')}</span></div>
          <input type="range" id="ba-range" min="0" max="100" value="50" aria-label="Comparar antes y con tu rutina">
        </div>
        <p class="ba-note">${ic('camera')}<span>Imágenes ilustrativas. Los resultados varían según cada persona.</span></p>
      </div>
      <div class="ba-copy">
        <span class="eyebrow">Antes / con tu rutina</span>
        <h2>Misma hora, otro día</h2>
        <p class="lead">Toma el círculo del centro y deslízalo para ver la diferencia.</p>
        <ul class="ba-points">
          ${k.baPoints.map(([i, t, d]) => `<li><span class="bp-ic">${ic(i)}</span><div><b>${t}</b><p>${d}</p></div></li>`).join('')}
        </ul>
        <a class="btn btn-cta" href="#ofertas">Ver las ofertas ${ic('arrow')}</a>
      </div>
      </div>
    </div>
  </section>

  <section class="sec" id="rutina">
    <div class="wrap">
      <div class="sec-head" data-rv>
        <span class="eyebrow">Tu rutina en ${k.products.length} productos</span>
        <h2>${k.solTitle}</h2>
        <p class="lead">${k.solSub}</p>
      </div>
      <div class="products" data-rv-group>
        ${k.products.map((p, i) => `
        <article class="product">
          <span class="product-n">${i + 1}</span>
          ${p.only ? '<span class="product-only">Solo en el Completo</span>' : ''}
          ${shot(p.img, p.name)}
          <div class="product-body">
            <span class="product-brand">${p.brand}</span>
            <h3>${p.name}</h3>
            ${p.tags ? `<div class="tags">${p.tags.map((t) => `<span>${t}</span>`).join('')}</div>` : ''}
            <p>${p.line}</p>
            <div class="facts"><div class="facts-h">Según la etiqueta</div>${p.facts.map(([a, b]) => `<div class="facts-row"><span>${a}</span><b>${b}</b></div>`).join('')}</div>
          </div>
        </article>`).join('')}
      </div>
    </div>
  </section>

  <section class="sec-tight">
    <div class="wrap">
      <div class="compare-wrap" data-rv>
        <table class="compare">
          <thead><tr><th scope="col">Comparado</th><th scope="col" class="us">${k.short}</th><th scope="col">Por separado</th></tr></thead>
          <tbody>
            <tr><td>Pedidos y envíos</td><td class="us"><b>1 y 1, gratis</b></td><td class="no">Uno por tienda</td></tr>
            <tr><td>Pagas al recibir</td><td class="us yes">${ic('check')}</td><td class="no">Depende de la tienda</td></tr>
            <tr><td>Etiqueta real de cada frasco a la vista</td><td class="us yes">${ic('check')}</td><td class="no">A veces</td></tr>
            <tr><td>Guía de 30 días de regalo</td><td class="us yes">${ic('check')}</td><td class="no">${ic('x')}</td></tr>
            <tr><td>Precio (Completo)</td><td class="us"><b>$49.900</b></td><td class="no">$134.700*</td></tr>
          </tbody>
        </table>
      </div>
      <p class="ba-note">*Suma de los 3 productos a nuestro precio por unidad.</p>
    </div>
  </section>

  <section class="sec alt">
    <div class="wrap easy">
      <div class="slot" data-rv><img src="${AS_A}img-clientes-facil-de-tomar-${key}.webp" alt="Tomando el suplemento en casa" loading="lazy" decoding="async"></div>
      <div class="problem-text" data-rv>
        <span class="eyebrow" style="justify-self:start">Fácil de tomar</span>
        <h2>Tu rutina, sin pensarlo</h2>
        <ul class="checklist">${k.easy.map(([t, d]) => `<li><span class="ck">${ic('check')}</span><span><b>${t}:</b> <span style="font-weight:500;color:var(--muted)">${d}</span></span></li>`).join('')}</ul>
        <p>La clave es la constancia: la misma rutina, todos los días.</p>
        <a class="btn btn-cta" href="#ofertas" style="justify-self:start">Quiero el mío ${ic('arrow')}</a>
      </div>
    </div>
  </section>

  <section class="sec">
    <div class="wrap">
      <div class="sec-head center" data-rv>
        <span class="eyebrow">Para tu día a día</span>
        <h2>Donde más lo necesitas</h2>
      </div>
      <div class="days" data-rv-group>${k.days.map(dayCard).join('')}</div>
    </div>
  </section>

  <section class="sec alt">
    <div class="wrap">
      ${bigQuote(key)}
      <div class="sec-head center" data-rv>
        <span class="eyebrow">Por qué en kit</span>
        <h2>Todo lo que ganas al pedirlo junto</h2>
      </div>
      <div class="benefits" data-rv-group>
        ${[['box', '1 solo pedido'], ['truck', '1 solo envío, gratis'], ['cash', 'Pagas al recibir'], ['lock', 'Sello de seguridad en cada frasco'], ['tag', 'Ahorras frente a comprar por separado'], ['check', 'Rutina lista, sin pensar']].map(([i, t]) => `<div class="benefit"><span class="seal-ic">${ic(i)}</span><b>${t}</b></div>`).join('')}
      </div>
    </div>
  </section>

  <section class="sec" id="ofertas">
    <div class="wrap offer">
      <div class="offer-top" data-rv>
        <span class="eyebrow">Elige tu kit</span>
        <h2>${STORE.offerName}</h2>
        <div class="countdown" data-countdown>${ic('clock')}<span>Termina el ${STORE.offerEndText}</span><span class="cd">--</span></div>
        <p class="offer-why">${STORE.offerWhy}</p>
        <span class="ship-free">${ic('truck')}Envío GRATIS a todo Chile</span>
      </div>
      <div class="packs" data-rv-group>${packCard('basico')}${packCard('completo')}</div>
      <div class="stack" data-stack aria-live="polite"></div>
      <div class="disc-banner">${ic('check')}Tu descuento de bienvenida no se junta con el precio del kit</div>
      <div class="offer-cta">
        <button class="btn btn-cta btn-block" type="button" data-order>Pedir y pagar al recibir ${ic('arrow')}</button>
        <p class="offer-trust">Pagas en tu casa al recibir · Garantía de 30 días · Despacho en 24–48 h</p>
      </div>
    </div>
  </section>

  <section class="sec alt">
    <div class="wrap">
      <!-- [2026-09-27] se quitó el recuadro "Este kit todavía no tiene reseñas"
           (5 estrellas + texto + botón): pedido de Jacsson, que prefiere dejar
           directamente las reseñas de ejemplo que hicimos nosotros. Contradecía
           a las tarjetas de más abajo y repetía el botón "Ver las ofertas".
           Los avisos de que las opiniones son ejemplos siguen donde estaban:
           la línea bajo el título "Opiniones" y el cartel de cada tarjeta. -->
      <div class="sec-head center" data-rv style="margin-bottom:18px">
        <!-- [anterior] "Clientes que ya tienen su rutina": afirmaba que había
             clientes sobre reseñas que son de ejemplo. -->
        <h2>Opiniones</h2>
        <span class="reviews-note">Ejemplos de cómo se van a ver · todavía no hay reseñas reales</span>
      </div>
    </div>
    <div class="marquee rev" data-reviews></div>
  </section>

  <section class="sec">
    <div class="wrap">
      <div class="sec-head center" data-rv>
        <span class="eyebrow">A los 30 días</span>
        <h2>Lo que le vamos a preguntar a cada cliente</h2>
      </div>
      <div class="results" data-rv-group>
        <div class="result-stat"><b>${ic('calendar')}</b><span>¿Alcanzaste a incorporarlo a tu día?</span></div>
        <div class="result-stat"><b>${ic('cart')}</b><span>¿Volverías a pedir tu kit?</span></div>
        <div class="result-stat"><b>${ic('users')}</b><span>¿Se lo recomendarías a alguien?</span></div>
        <div class="result-stat"><b>${ic('box')}</b><span>¿Te quedaste con el Básico o el Completo?</span></div>
      </div>
      <p class="results-note">Te escribimos a los 30 días de tu pedido. Cuando tengamos respuestas suficientes, publicamos aquí los resultados con el número de personas que contestó.</p>
    </div>
  </section>

  <section class="sec-tight">
    <div class="wrap">
      <div class="promise" data-rv>
        <span class="promise-halo" aria-hidden="true"></span>
        <span class="promise-seal"><span>30<small>días</small></span></span>
        <span class="eyebrow">Compra sin riesgo</span>
        <h2>Nuestra promesa</h2>
        <p>Pagas cuando lo recibes. Y si algo no te convence, tienes 30 días desde que llega para pedir la devolución, según nuestra política de reembolso.</p>
        <div class="promise-grid">
          <div class="pg-item"><span class="pg-ic">${ic('cash')}</span><b>No adelantas nada</b><span>Pagas en tu casa, al recibir el pedido.</span></div>
          <div class="pg-item"><span class="pg-ic">${ic('shield')}</span><b>30 días para decidir</b><span>Si no te convence, pides la devolución.</span></div>
          <div class="pg-item"><span class="pg-ic">${ic('truck')}</span><b>Envío gratis</b><span>A todo Chile, en un solo paquete.</span></div>
        </div>
        <a class="btn btn-cta btn-lg" href="#ofertas">Elegir mi kit ${ic('arrow')}</a>
        <span class="promise-fine">Sin letra chica: puedes leer la política completa en <a href="politicas.html">Políticas de la tienda</a>.</span>
      </div>
    </div>
  </section>

  <section class="sec">
    <div class="wrap">
      <div class="forwho" data-rv-group>
        <div class="fw-col yes"><h3>Para quién es</h3><ul>${k.forwho.yes.map((t) => `<li>${ic('check')}<span>${t}</span></li>`).join('')}</ul></div>
        <div class="fw-col no"><h3>Para quién no es</h3><ul>${k.forwho.no.map((t) => `<li>${ic('x')}<span>${t}</span></li>`).join('')}</ul></div>
      </div>
    </div>
  </section>

  <section class="sec alt">
    <div class="wrap narrow">
      <div class="sec-head center" data-rv>
        <span class="eyebrow">Preguntas de clientes</span>
        <h2>Lo que más nos preguntan</h2>
      </div>
      <div class="faq" data-rv-group>${k.faq.map(([q, a]) => `<details><summary>${q}${ic('plus')}</summary><p class="faq-a">${a}</p></details>`).join('')}</div>
    </div>
  </section>

  <section class="sec-tight">
    <div class="wrap">
      <div class="seals" data-rv-group>
        <div class="seal"><span class="seal-ic">${ic('truck')}</span><b>Envío gratis</b><span>A todo Chile</span></div>
        <div class="seal"><span class="seal-ic">${ic('clock')}</span><b>Despacho 24–48 h</b><span>Recíbelo en pocos días</span></div>
        <div class="seal"><span class="seal-ic">${ic('shield')}</span><b>Garantía 30 días</b><span>Compra sin riesgo</span></div>
        <div class="seal"><span class="seal-ic">${ic('cash')}</span><b>Paga en tu casa</b><span>Cuando recibes tu pedido</span></div>
      </div>
    </div>
  </section>


  <section class="final wrap" data-rv>
    <span class="eyebrow">Empieza hoy</span>
    <h2>Una rutina, no un milagro.</h2>
    <a class="btn btn-cta" href="#ofertas">Ver ofertas ${ic('arrow')}</a>
  </section>`;

  const foot = document.querySelector('[data-footer]');
  if (foot) foot.dataset.legal = k.legal; // renderKit debe correr antes de chrome()

  // barra fija de compra
  document.body.insertAdjacentHTML('beforeend', `
  <div class="buybar" aria-hidden="true">
    <div class="wrap">
      <div class="buybar-info"><b>${k.short}</b><span>desde $44.900 · pagas al recibir</span></div>
      <a class="btn btn-cta" href="#ofertas" tabindex="-1">Comprar ahora</a>
    </div>
  </div>
  <div class="modal" role="dialog" aria-modal="true" aria-labelledby="up-title">
    <div class="modal-card">
      <span class="eyebrow" style="justify-self:start">${ic('gift')}Antes de pagar…</span>
      <h3 id="up-title">¿Pasas al Completo por solo $5.000 más?</h3>
      <div class="modal-gift">${shot(p3.img, p3.name)}<div><b>${p3.name}</b><p style="color:var(--muted);font-size:.9rem">Sumas ${k.upsell} y te ahorras ${clp(KIT_PACKS.completo.strike - KIT_PACKS.completo.price)} en total.</p></div></div>
      <button class="btn btn-cta btn-block" type="button" data-upgrade>Sí, lo quiero</button>
      <button class="link-btn" type="button" data-decline>No, gracias, continuar con el Básico</button>
    </div>
  </div>`);
}

/* ---------- interacciones de la página de kit ---------- */
function kitInteractions() {
  // deslizador antes / después
  const ba = document.querySelector('.ba'), range = document.getElementById('ba-range');
  if (ba && range) {
    const set = (v) => ba.style.setProperty('--pos', v + '%');
    range.addEventListener('input', () => set(range.value));
    // pista de uso: un barrido suave la primera vez que aparece
    if (!matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([e]) => {
        if (!e.isIntersecting) return;
        io.disconnect();
        const seq = [50, 22, 78, 50], t0 = performance.now(), dur = 2200;
        const run = (t) => {
          const p = Math.min(1, (t - t0) / dur), seg = Math.min(2, Math.floor(p * 3)), local = p * 3 - seg;
          const ease = 0.5 - Math.cos(local * Math.PI) / 2;
          const v = seq[seg] + (seq[seg + 1] - seq[seg]) * ease;
          set(v); range.value = v;
          if (p < 1) requestAnimationFrame(run);
        };
        requestAnimationFrame(run);
      }, { threshold: 0.6 });
      io.observe(ba);
    }
  }

  // barra fija: aparece después del hero y se esconde en las ofertas
  const bar = document.querySelector('.buybar'), hero = document.querySelector('.kit-hero'), offer = document.getElementById('ofertas');
  let pastHero = false, inOffer = false;
  const upd = () => { const on = pastHero && !inOffer; bar.classList.toggle('show', on); document.body.classList.toggle('has-buybar', on); };
  new IntersectionObserver(([e]) => { pastHero = !e.isIntersecting; upd(); }).observe(hero);
  new IntersectionObserver(([e]) => { inOffer = e.isIntersecting; upd(); }, { threshold: 0.25 }).observe(offer);

  const key = document.body.dataset.page, k = KITS[key];
  const syncStack = () => renderStack(k, document.querySelector('input[name="pack"]:checked').value);
  document.querySelectorAll('input[name="pack"]').forEach((r) => r.addEventListener('change', syncStack));
  syncStack();

  // pedido y venta adicional
  const modal = document.querySelector('.modal');
  const open = () => { modal.classList.add('open'); modal.querySelector('[data-upgrade]').focus(); };
  const close = () => modal.classList.remove('open');
  const done = (pack) => ASTienda.pedirKit(pack);
  document.querySelector('[data-order]').addEventListener('click', () => {
    const v = document.querySelector('input[name="pack"]:checked').value;
    if (v === 'basico') open(); else done('Completo');
  });
  modal.querySelector('[data-upgrade]').addEventListener('click', () => { document.getElementById('pack-completo').checked = true; syncStack(); close(); done('Completo'); });
  modal.querySelector('[data-decline]').addEventListener('click', () => { close(); done('Básico'); });
  modal.addEventListener('click', (e) => { if (e.target === modal) close(); });
  addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
}
